import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * Handing website enquiries and help desk queries to centers.
 *
 * source is "enquiry" for anything that came through the website, "query" for
 * the help desk. One query can be with several centers at once.
 */

const adminToken = () => localStorage.getItem("adminToken");

/** Who each of these queries is already with, for a whole page at a time. */
export const getAssignments = (source, ids) => async (dispatch) => {
  try {
    const q = new URLSearchParams();
    q.append("source", source);
    (ids || []).forEach((id) => q.append("query_id[]", id));

    const response = await dispatch(
      getDataAPI(`admin/query/assigned?${q.toString()}`, adminToken())
    );
    return response.data.data || {};
  } catch (error) {
    return {};
  }
};

/** Give one query to a set of centers. replace makes it the whole list. */
export const assignToCenters =
  (source, queryId, centerIds, replace) => async (dispatch) => {
    try {
      const body = new FormData();
      body.append("source", source);
      body.append("query_id", queryId);
      if (replace) body.append("replace", 1);
      (centerIds || []).forEach((id) => body.append("center_id[]", id));

      const response = await dispatch(
        postDataAPI("admin/query/assign", body, adminToken())
      );
      successAlert(response.data.message);
      return response.data.data || [];
    } catch (error) {
      errorAlert(
        error.response?.data?.message || "The query could not be assigned."
      );
      return false;
    }
  };
